import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { FavouritesProvider } from "./lib/favourites";
import { ParticipationProvider } from "./lib/participation";
import Home from "./pages/Home";
import News from "./pages/News";
import { NewsStoreProvider } from "./lib/newsStore";
import Volunteer from "./pages/Volunteer";
import About from "./pages/About";
import OpportunityDetail from "./pages/OpportunityDetail";
import Pulse from "./pages/Pulse";
import Fundraisers from "./pages/Fundraisers";
import Events from "./pages/Events";
import ActionIndex from "./pages/ActionIndex";
import MyActions from "./pages/MyActions";
import Organizations from "./pages/Organizations";
import OrganizationProfile from "./pages/OrganizationProfile";
import ClaimOrganization from "./pages/ClaimOrganization";
import AdminClaims from "./pages/AdminClaims";

function App() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] font-body text-slate-700">
      <FavouritesProvider>
      <ParticipationProvider>
      <NewsStoreProvider>
      <BrowserRouter>
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/news" element={<News />} />
            <Route path="/barometer" element={<Navigate to="/news?tab=sentiment" replace />} />
            <Route path="/pulse" element={<Pulse />} />
            <Route path="/fundraisers" element={<Fundraisers />} />
            <Route path="/events" element={<Events />} />
            <Route path="/action-index" element={<ActionIndex />} />
            <Route path="/impact" element={<Navigate to="/action-index" replace />} />
            <Route path="/my-actions" element={<MyActions />} />
            <Route path="/organizations" element={<Organizations />} />
            <Route path="/organizations/:slug" element={<OrganizationProfile />} />
            <Route path="/organizations/:slug/claim" element={<ClaimOrganization />} />
            <Route path="/admin/claims" element={<AdminClaims />} />
            <Route path="/volunteer" element={<Volunteer />} />
            <Route path="/volunteer/:id" element={<OpportunityDetail />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
      </NewsStoreProvider>
      </ParticipationProvider>
      </FavouritesProvider>
    </div>
  );
}

export default App;
